import { Component } from '@angular/core';

import { FieldBaseComponent } from '../base-component';
import { FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgClass } from '@angular/common';
import { Observable, defer, isObservable, of } from 'rxjs';

@Component({
  selector: 'app-lib-ff-custom-checkbox',
  styleUrls: ['custom-checkbox.component.scss'],
  templateUrl: 'custom-checkbox.component.html',
  imports: [
    FormlyModule,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    AsyncPipe,
  ],
})
export class FormlyCustomCheckboxListComponent extends FieldBaseComponent {
  public onChange(value, checked) {
    this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
    this.formControl.markAsTouched();
  }
  public get hasOnlyText() {
    return (this.props.options as any[]).every((x) => x.label && !x.icon);
  }
  public isChecked(id) {
    return this.formControl.value[id];
  }

  public readonly options$: Observable<any[]> = defer(() => {
    const options = this.props?.options;
    return isObservable(options) ? options : of(options ?? []);
  });
}
